// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._6eLUO {\n  padding: var(--space-100) !important;\n  border-radius: var(--radius-75);\n}\n._6eLUO:hover {\n    background-color: var(--surface-brand-hover);\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"anchorButton": "_6eLUO"
};
export default ___CSS_LOADER_EXPORT___;
